// extracted by mini-css-extract-plugin
export var bullet = "_sf-q";
export var bulletText = "_sf-p";
export var bullets = "_sf-k";
export var callout = "_sf-g";
export var calloutBody = "_sf-i";
export var calloutLabel = "_sf-h";
export var checkIcon = "_sf-m";
export var checkList = "_sf-j";
export var checkSvg = "_sf-n";
export var checkText = "_sf-o";
export var fieldCard = "_sf-1";
export var fieldDescription = "_sf-5";
export var fieldHeader = "_sf-3";
export var fieldTitle = "_sf-4";
export var finalNote = "_sf-s";
export var flow = "_sf-x";
export var flowArrow = "_sf-v";
export var flowStep = "_sf-u";
export var helperText = "_sf-r";
export var inlineTitle = "_sf-t";
export var listItem = "_sf-l";
export var noteBody = "_sf-8";
export var noteBodyText = "_sf-9";
export var noteCard = "_sf-2";
export var noteIcon = "_sf-6";
export var noteTitle = "_sf-7";
export var productChoices = "_sf-w";
export var radioDot = "_sf-d";
export var radioDotSelected = "_sf-e";
export var radioDotSvg = "_sf-f";
export var selectableCard = "_sf-b";
export var selectableCardSelected = "_sf-c";
export var strongText = "_sf-a";
export var subHeading = "_sf-0";